import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const speedToLeadApi = createApi({
  reducerPath: "speedToLeadApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["SpeedToLeadSettings"],
  keepUnusedDataFor: 300, // Keep cache for 5 minutes after unmount
  endpoints: (build) => ({
    // Get current settings + defaults
    getSpeedToLeadSettings: build.query({
      query: () => ({ url: "/speed-to-lead/settings", method: "GET" }),
      providesTags: ["SpeedToLeadSettings"],
      transformResponse: (res) => res.data || res,
    }),

    // Update settings
    updateSpeedToLeadSettings: build.mutation({
      query: (body) => ({ url: "/speed-to-lead/settings", method: "PUT", body }),
      invalidatesTags: ["SpeedToLeadSettings"],
    }),

    // Get default templates
    getSpeedToLeadTemplates: build.query({
      query: () => ({ url: "/speed-to-lead/templates", method: "GET" }),
      transformResponse: (res) => res.data || res,
    }),
  }),
});

export const {
  useGetSpeedToLeadSettingsQuery,
  useUpdateSpeedToLeadSettingsMutation,
  useGetSpeedToLeadTemplatesQuery,
} = speedToLeadApi;
